import { Component, Input, OnInit } from '@angular/core';
import { IncidentTyre } from '../../../models/incident';
import { AppModule } from '../../../app.module';
import { TyreLocation } from '../../../shared/enums';
import { SharedDataService } from '../../../shared/shareddata.service';
import { ValidationBorderDirective } from '../../../shared/validation-border.directive';


@Component({
  selector: 'app-incident-tyre',
  imports: [AppModule, ValidationBorderDirective],
  templateUrl: './incident-tyre.html',
  styleUrl: './incident-tyre.less'
})
export class IncidentTyreComponent implements OnInit {

  @Input() public incidentTyre: IncidentTyre;


  constructor(public sharedDataService: SharedDataService) {
    
  }

  ngOnInit(): void {
    // Check min and max ans adjust to min if less than min
    // const range = this.getTyreLocationRange();
    // if (this.incidentTyre.tyreNumber < range.min || this.incidentTyre.tyreNumber > range.max) {
    //   this.incidentTyre.tyreNumber = range.min;
    // }

  }

  getTyreLocationString(): string {
    return TyreLocation[this.incidentTyre.tyreLocation].toUpperCase();
  }

  getTyreLocationRange(): {min: number, max: number} {
    switch (this.incidentTyre.tyreLocation) {
      case TyreLocation.steer:
        return {min: 1, max: 2 };
      case TyreLocation.drive:
        return {min: 3, max: 8 };
      case TyreLocation.trailer:
        return {min: 11, max: 48 };
    }
    return {min: 0, max: 0};
  }
}
